import React, { useState, useEffect, useRef } from "react";
import { FaCalendarAlt, FaUser } from "react-icons/fa";
import { IoAddCircleOutline, IoRemoveCircleOutline } from "react-icons/io5";
import { usePage, router } from "@inertiajs/react";
import PropTypes from "prop-types";
import FilterOptions from "@/features/search/FilterOptions";
import { useTranslation } from "react-i18next";

import searchbutton from "@/assets/SearchButton.svg";
import locationlist from "@/assets/locationlist.svg";
import SearchBar from "@/components/SearchBar";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { setSearchTerm } from "@/store/slices/modalSlice";

const Filters = ({ isOpen, onClose, setFly }) => {

    const { filtersData, selectedFilters, locale } = usePage().props;
    const searchTerm = useSelector((state: RootState) => state.modal.searchTerm)
    const dispatch = useDispatch()

    //*Type Filters
    const [accomodationTypes, setAccomodationTypes] = useState(
        selectedFilters.accomodation_types ?? [],
    );

    const [businessTypes, setBusinessTypes] = useState(
        selectedFilters.business_types ?? [],
    );

    const [eventTypes, setEventTypes] = useState(
        selectedFilters.event_types ?? [],
    );

    const [activityTypes, setActivityTypes] = useState(
        selectedFilters.activity_types ?? [],
    );
    const [placeTypes, setPlaceTypes] = useState(
        selectedFilters.place_types ?? [],
    );

    const [areas, setAreas] = useState(selectedFilters.area ?? []);
    //* Other filters
    const [arrivalDate, setArrivalDate] = useState("");
    const [departureDate, setDepartureDate] = useState("");
    const [adults, setAdults] = useState<number>(selectedFilters.adults ?? 1);
    const [children, setChildren] = useState<number>(selectedFilters.children ?? 0);

    const [eventFrom, setEventFrom] = useState(selectedFilters.event_from ?? "");
    const [eventTo, setEventTo] = useState(selectedFilters.event_to ?? "");


    const modalRef = useRef(null);

    useEffect(() => {
        dispatch(setSearchTerm(selectedFilters.name))
    }, [])

    const { t } = useTranslation(["common", "glossary"]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose])

    useEffect(() => {
        const preventBackgroundScroll = () => {
            if (isOpen && window.innerWidth <= 767) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "auto";
            }
        };

        preventBackgroundScroll();
        window.addEventListener("resize", preventBackgroundScroll);

        return () => {
            document.body.style.overflow = "auto";
            window.removeEventListener("resize", preventBackgroundScroll);
        };
    }, [isOpen])

    const handleGuestChange = (type: 'adults' | 'children', increment: number) => {
        if (type === "adults") {
            setAdults((prevAdults) => Math.max(1, prevAdults + increment));
        } else if (type === "children") {
            setChildren((prevChildren) =>
                Math.max(0, prevChildren + increment),
            );
        }
    };

    const clearFilters = () => {
        setAccomodationTypes([]);
        setBusinessTypes([]);
        setEventTypes([]);
        setActivityTypes([]);
        setPlaceTypes([]);
        setAreas([]);
        setArrivalDate("");
        setDepartureDate("");
        setEventFrom("");
        setEventTo("");
        setAdults(1);
        setChildren(0);
        setSearchTerm("")
        dispatch(setSearchTerm(''))
    };

    const applyFilters = () => {
        //get scopes params from url
        let scopesParams = new URLSearchParams(document.location.toString());

        let scopes = [];
        for (const [key, value] of scopesParams.entries()) {
            if (key.startsWith("searchScope[")) {
                scopes.push({ key, value });
            }
        }
        const params = new URLSearchParams();
        //add scopes params no new
        scopes.forEach((item) => {
            params.append(item.key, item.value);
        });

        if (accomodationTypes.length > 0) {
            accomodationTypes.forEach((type) => {
                params.append("accomodation_types[]", type);
            });
        }

        if (businessTypes.length > 0) {
            businessTypes.forEach((type) => {
                params.append("business_types[]", type);
            });
        }

        if (eventTypes.length > 0) {
            eventTypes.forEach((type) => {
                params.append("event_types[]", type);
            });
        }

        if (activityTypes.length > 0) {
            activityTypes.forEach((type) => {
                params.append("activity_types[]", type);
            });
        }

        if (placeTypes.length > 0) {
            placeTypes.forEach((type) => {
                params.append("place_types[]", type);
            });
        }

        if (areas.length > 0) {
            areas.forEach((area) => {
                params.append("area[]", area);
            });
        }
        if (arrivalDate) params.append("check-in", arrivalDate);
        if (departureDate) params.append("check-out", departureDate);
        if (eventFrom) params.append("event_from", eventFrom);
        if (eventTo) params.append("event_to", eventTo);
        // params.append("adults", adults);
        // params.append("children", children);
        if (searchTerm) params.append("name", searchTerm);
        setFly(false);

        router.get(
            `/${locale}/search?${params.toString()}`,
            {},
            {
                preserveState: true,
                onSuccess: () => {
                    onClose();
                },
            },
        );
    };

    return (
        <div
            ref={modalRef}
            className={`fixed xl:w-[39%] md:w-1/2 w-full rounded-r-xl mt-20 inset-0 bg-white shadow-lg z-50 transition-transform transform ${isOpen ? "translate-x-0" : "-translate-x-full"} ${isOpen && window.innerWidth <= 767 ? "overflow-y-auto max-h-screen" : ""}`}
        >
            <div className="p-4 flex flex-col h-full">
                <button
                    title="close"
                    onClick={onClose}
                    className="absolute text-5xl top-4 right-8 text-black"
                >
                    &times;
                </button>

                <div className="xl:hidden mt-16 flex relative ">
                    <SearchBar closeFilters={onClose} />
                </div>



                <div className="w-1/2 ">

                    <div className="flex flex-col gap-4 mb-4 ">

                        {/*<div className="flex md:flex-row flex-col flex-wrap w-full gap-4 my-4">*/}
                        {/*    <div className="flex items-center min-w-none min-w-[200px] border border-[#1D26CA] rounded-lg p-2 w-full">*/}
                        {/*        <FaUser className="text-[#1D26CA] mr-2" />*/}
                        {/*        <h3 className="font-semibold mr-auto">*/}
                        {/*            {t("adults", { ns: "glossary" })}*/}
                        {/*        </h3>*/}
                        {/*        <button*/}
                        {/*            className="px-2 text-[#1D26CA]"*/}
                        {/*            onClick={() =>*/}
                        {/*                handleGuestChange("adults", -1)*/}
                        {/*            }*/}
                        {/*        >*/}
                        {/*            <IoRemoveCircleOutline className="text-xl" />*/}
                        {/*        </button>*/}
                        {/*        <span className="mx-2">{adults}</span>*/}
                        {/*        <button*/}
                        {/*            className="px-2 text-[#1D26CA]"*/}
                        {/*            onClick={() =>*/}
                        {/*                handleGuestChange("adults", 1)*/}
                        {/*            }*/}
                        {/*        >*/}
                        {/*            <IoAddCircleOutline className="text-xl" />*/}
                        {/*        </button>*/}
                        {/*    </div>*/}
                        {/*    <div className="flex items-center border min-w-[200px] border-[#1D26CA] rounded-lg p-2 w-full">*/}
                        {/*        <FaUser className="text-[#1D26CA] mr-2" />*/}
                        {/*        <h3 className="font-semibold min-w-[60px] mr-auto">*/}
                        {/*            {t("childs", { ns: "glossary" })}*/}
                        {/*        </h3>*/}
                        {/*        <button*/}
                        {/*            className="px-2 text-[#1D26CA]"*/}
                        {/*            onClick={() =>*/}
                        {/*                handleGuestChange("children", -1)*/}
                        {/*            }*/}
                        {/*        >*/}
                        {/*            <IoRemoveCircleOutline className="text-xl" />*/}
                        {/*        </button>*/}
                        {/*        <span className="px-2">{children}</span>*/}
                        {/*        <button*/}
                        {/*            className="px-2 text-[#1D26CA]"*/}
                        {/*            onClick={() =>*/}
                        {/*                handleGuestChange("children", 1)*/}
                        {/*            }*/}
                        {/*        >*/}
                        {/*            <IoAddCircleOutline className="text-xl" />*/}
                        {/*        </button>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </div>

                <div className="p-1 flex md:flex-grow md:overflow-y-auto flex-col ">
                    <FilterOptions
                        name={t("area", { ns: "glossary" })}
                        data={filtersData.areaType.data}
                        filters={areas}
                        setFilters={setAreas}
                    />
                    <FilterOptions
                        name={t("Accomodation", { ns: "glossary" })}
                        data={filtersData.accomodationType.data}
                        filters={accomodationTypes}
                        setFilters={setAccomodationTypes}
                    />
                    <FilterOptions
                        name={t("Activity", { ns: "glossary" })}
                        data={filtersData.activityType.data}
                        filters={activityTypes}
                        setFilters={setActivityTypes}
                    />
                    <FilterOptions
                        name={t("Business", { ns: "glossary" })}
                        data={filtersData.businessType.data}
                        filters={businessTypes}
                        setFilters={setBusinessTypes}
                    />
                    <FilterOptions
                        name={t("Event", { ns: "glossary" })}
                        data={filtersData.eventType.data}
                        filters={eventTypes}
                        setFilters={setEventTypes}
                    />
                    <div className="flex md:flex-row flex-wraps flex-col w-full gap-4">


                        <div className="w-full">
                            <h3 className="font-semibold mb-2">
                                {" "}
                                {t("from", { ns: "common" })}
                            </h3>

                            <div className="relative">
                                <FaCalendarAlt className="absolute  top-3 left-3 text-[#1D26CA]" />
                                <input
                                    type="date"
                                    className="w-full min-w-[200px] pl-10 p-2 border-[#1D26CA] min-w-none md:min-w-[200px] rounded-lg text-[#1D26CA] focus:outline-none focus:ring-0"
                                    value={eventFrom}
                                    onChange={(e) =>
                                        setEventFrom(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="w-full">
                            <h3 className="font-semibold min-w-[200px] mb-2">
                                {t("to", { ns: "common" })}
                            </h3>
                            <div className="relative">
                                <FaCalendarAlt className="absolute top-3 left-3 text-[#1D26CA]" />
                                <input
                                    type="date"
                                    className="w-full min-w-[200px] pl-10 p-2 border-[#1D26CA] rounded-lg text-[#1D26CA] focus:outline-none focus:ring-0"
                                    value={eventTo}
                                    onChange={(e) =>
                                        setEventTo(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <FilterOptions
                        name={t("Place", { ns: "glossary" })}
                        data={filtersData.placeType.data}
                        filters={placeTypes}
                        setFilters={setPlaceTypes}
                    />
                </div>

                <div className="flex justify-between py-4">
                    <button
                        title={t("clean_filters", { ns: "glossary" })}
                        className="bg-[#070F2B] text-white md:text-lg px-4 py-2 rounded-lg"
                        onClick={() => {
                            clearFilters();
                        }}
                    >
                        {t("clean_filters", { ns: "glossary" })}
                    </button>
                    <button
                        title={t("apply", { ns: "glossary" })}
                        className="bg-[#1D26CA] text-white md:text-lg px-8 py-2 rounded-lg"
                        onClick={applyFilters}
                    >
                        {t("apply", { ns: "glossary" })}
                    </button>
                </div>
            </div>
        </div>
    );
};

Filters.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default Filters;
